import * as React from "react";
const SvgArrowUp = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 11, viewBox: "0 0 12 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 1L6 11M6.2 1L1 6M5.8 1L11 6", stroke: "currentColor" }));
export default SvgArrowUp;
